import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationBlockedVisitors } from "../shared/data.service";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { BlockedVisitorExportRequest } from "../shared/BlockedVisitorExportRequest";

@Component({
	selector: "app-ms-blocked-visitor-export",
	templateUrl: "./ms-blocked-visitor-export.component.html",
	styleUrls: ["./ms-blocked-visitor-export.component.css"],
})
export class MsBlockedVisitorExportComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationBlockedVisitors, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.loadFormatOptions();
	}

	///////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////

	IncludeOffenders: boolean = false;
	IncludeHeaders: boolean = true;

	LoadingFormatOptions: boolean = false;
	lstFormatOptions: any = [];
	SelectedFormatOption: any;

	Processing: boolean = false;

	errorMessage: any = "";
	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////
	loadFormatOptions() {
		this.LoadingFormatOptions = true;

		var result = this.visitorService.ExportFormatOptionSelectList();
		result.subscribe(
			(response) => {
				this.lstFormatOptions = response;

				this.SelectedFormatOption = this.lstFormatOptions[0];
				this.LoadingFormatOptions = false;
			},
			(error) => {
				this.LoadingFormatOptions = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////
	onExport() {
		this.Processing = true;

		var parms: BlockedVisitorExportRequest = {
			IncludeOffenders: this.IncludeOffenders == true ? 1 : 0,
			FormatOptionID: this.SelectedFormatOption.ID,
			IncludeHeaders: this.IncludeHeaders == true ? 1 : 0,
		};

		var result = this.visitorService.BlockedVisitorExport(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				var Data: any = response[0];

				if (Data != undefined) {
					var a = document.createElement("a"); //Create <a>

					var FileName = "BlockedVisitors_Export_";

					//Text tab
					if (this.SelectedFormatOption.ID == 1) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//Text comma
					else if (this.SelectedFormatOption.ID == 2) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//CSV
					else if (this.SelectedFormatOption.ID == 3) {
						a.href = "data:text/csv;base64," + response[0];
						a.download = FileName + ".csv";
						a.click(); //Downloaded file
					}
				} else {
					this.errorMessage = "Error Exporting Data";
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingFormatOptions == true || this.Processing == true;
	}
	///////////////////////////////////////////////////////////////////////
}
